/**
 * Resolves a multi-language field (e.g. Product.productName, AddOn.name -
 * { en: "Cheese", ar: "جبنة" }) to a single display string.
 *
 * The Admin UI itself is English-only (unlike the customer-facing
 * ClientApp, which switches by locale), so this always prefers English
 * and falls back to whatever's first - it never shows the raw object.
 * Also tolerates a plain string, for any data not yet migrated to the
 * multi-language shape.
 */
export const getLocalizedName = (value) => {
  if (!value) return "";
  if (typeof value === "string") return value;
  return value.en || Object.values(value)[0] || "";
};
